export default __webpack_public_path__ + "static/media/DE5.b758fc44.svg";